module.exports = __webpack_public_path__ + "static/img/loader.edf4241.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = 314
// module chunks = 1